export const RequestsEnum = Object.freeze({
  marketplaceGetListings: 1,
  searchGetSneakers: 2,
  productGetSneaker: 3,
  productGetListings: 4,
  buyGetSneaker: 5,
  buyGetListings: 6,
  buyPurchaseListing: 7,
  sellGetSneaker: 8,
  sellGetUnlistedItems: 9,
  sellCreateListing: 10,
  profileGetUser: 11,
  profileGetItems: 12,
  profileGetActiveListings: 13,
  listingGetListing: 14,
  listingUpdateListing: 15,
  productGetIsWatchlistItem: 16,
  productCreateWatchlistItem: 17,
  productDeleteWatchlistItem: 18,
  profileGetWatchlist: 19,
  landingAddEmail: 20,
  landingAddPageView: 21,
  adminGetWaitlist: 22,
  adminAddSneaker: 23,
  transferMoneyGetBankAccount: 24,
  transferMoneyTransfer: 26,
  transferMoneyMakeTransfer: 27,
  transferMoneyGetAccountBalance: 28,
  transferMoneyInitiatePlaid: 29,
  transferMoneyCreateLinkToken: 30,
  profileCreateUser: 31,
  adminAddItem: 32,
});
